export function FaqSection({ faqs, title }: { faqs: { q: string; a: string }[]; title?: string }) {
  return (
    <section id="gold-faqs" className="mx-auto max-w-4xl px-4 py-10">
      <h2 className="text-2xl font-bold mb-4">{title ?? "Frequently asked questions"}</h2>
      <div className="space-y-5">
        {faqs.map((f) => (
          <div key={f.q} className="rounded-xl border border-border bg-card p-5">
            <h3 className="font-semibold text-base">{f.q}</h3>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{f.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}